import * as Yup from 'yup';

export default (t: any) => Yup.object().shape({
  // Próg jak w backendzie — krótsze hasło odrzuciłby dopiero serwer, z ogólnym błędem aktywacji
  password: Yup.string()
    .min(10, t('common:validation.password.minLength'))
    .max(100, t('common:validation.password.tooLong'))
    .required(t('common:validation.password.required')),
});

export type Values = {
  password: string;
};

export const INITIAL_VALUES: Values = {
  password: '',
};
